
// src/api/services/auth.js
import apiClient from '../client';

export const authService = {
    register: (data) => apiClient.post('/api/auth/register', data),
    login: (credentials) => apiClient.post('/api/auth/login', credentials),
    logout: () => {
        localStorage.removeItem('token');
        //localStorage.removeItem('refreshToken');
    },
    getCurrentUser: () => apiClient.get('/api/user/profile'),
};